import { createAction } from 'redux-actions'

const ns = 'settings/'

/*export const getUserActivity = createAction(`${ns}GET_USER_ACTIVITY`)
export const getUserActivitySuccess = createAction(`${ns}GET_USER_ACTIVITY_SUCCESS`)
export const getUserActivityFail = createAction(`${ns}GET_USER_ACTIVITY_FAIL`)*/

/*export const getUserBadges = createAction(`${ns}GET_USER_BADGES`)
export const getUserBadgesSuccess = createAction(`${ns}GET_USER_BADGES_SUCCESS`)
export const getUserBadgesFail = createAction(`${ns}GET_USER_BADGES_FAIL`)*/

export const getCompanyDivisions = createAction(`${ns}GET_COMPANY_DIVISIONS`)
export const getCompanyDivisionsSuccess = createAction(`${ns}GET_COMPANY_DIVISIONS_SUCCESS`)
export const getCompanyDivisionsFail = createAction(`${ns}GET_COMPANY_DIVISIONS_FAIL`)

export const getUserCompanyCountries = createAction(`${ns}GET_USER_COMPANY_COUNTRIES`)
export const getUserCompanyCountriesSuccess = createAction(`${ns}GET_USER_COMPANY_COUNTRIES_SUCCESS`)
export const getUserCompanyCountriesFail = createAction(`${ns}GET_USER_COMPANY_COUNTRIES_FAIL`)

export const updateUser = createAction(`${ns}UPDATE_USER`)
export const updateUserSuccess = createAction(`${ns}UPDATE_USER_SUCCESS`)
export const updateUserFail = createAction(`${ns}UPDATE_USER_FAIL`)

export const deleteUser = createAction(`${ns}DELETE_USER`)

export const changePassword = createAction(`${ns}CHANGE_PASSWORD`)
export const joinCompany = createAction(`${ns}JOIN_COMPANY`)
export const setUserDivision = createAction(`${ns}SET_USER_DIVISION`)
export const setUserCountry = createAction(`${ns}SET_USER_COUNTRY`)

export const leaveCompany = createAction(`${ns}LEAVE_COMPANY`)
export const deleteUserOwnedCompany = createAction(`${ns}DELETE_USER_OWNED_COMPANY`)

export const togglePublicStatus = createAction(`${ns}TOGGLE_PUBLIC_STATUS`)
